module.exports = __webpack_public_path__ + "img/coretests.c04035fe.png";